import { senderBackSuppressErrorToast } from './sender-back-request';
import { api } from './http';

export type PanelSenderSessionRow = {
	id: string;
	status: string;
	displayStatus: 'ready' | 'running' | 'archived' | 'pending' | 'failed' | 'expired';
	phoneMasked: string;
	username: string | null;
	label: string | null;
	createdAt: string;
	authorizedAt: string | null;
	presetName: string | null;
	landingHostname: string | null;
	contactsCount: number | null;
	dialogsCount: number | null;
};

export async function fetchPanelSenderSessions(params?: {
	status?: 'ready' | 'archived';
	limit?: number;
}) {
	const { data } = await api.get<{ items: PanelSenderSessionRow[] }>('/sender/sessions', {
		params,
	});
	return data.items;
}

export async function bulkSpamPanelSessions(body: {
	sessionIds: string[];
	presetId?: string;
}) {
	const { data } = await api.post<{
		created: { sessionId: string; runId: string }[];
		skipped: { sessionId: string; reason: string }[];
		errors: { sessionId: string; message: string }[];
	}>('/sender/sessions/bulk-spam', body, senderBackSuppressErrorToast);
	return data;
}

export type ExportPanelSenderSessionsBody =
	| { sessionIds: string[] }
	| { listStatus: 'ready' | 'archived' };

export async function exportPanelSenderSessions(body: ExportPanelSenderSessionsBody) {
	const response = await api.post<Blob>('/sender/sessions/export', body, {
		responseType: 'blob',
		...senderBackSuppressErrorToast,
	});
	return response.data;
}

export async function archivePanelSenderSession(sessionId: string) {
	await api.post(`/sender/sessions/${sessionId}/archive`, undefined, senderBackSuppressErrorToast);
}

export async function importPanelSenderSessionFile(file: File) {
	const form = new FormData();
	form.append('session', file);
	const { data } = await api.post<{ sessionId: string; fileName: string }>(
		'/sender/sessions/import-file',
		form,
		{
			headers: { 'Content-Type': 'multipart/form-data' },
			...senderBackSuppressErrorToast,
		},
	);
	return data;
}

export async function uploadPanelSenderSessionsZip(file: File) {
	const form = new FormData();
	form.append('file', file);
	const { data } = await api.post<{
		imported: { sessionId: string; fileName: string }[];
		errors: { fileName: string; reason: string }[];
	}>('/sender/sessions/upload-zip', form, {
		headers: { 'Content-Type': 'multipart/form-data' },
		...senderBackSuppressErrorToast,
	});
	return data;
}
